module.exports = __webpack_public_path__ + "img/default_long.63b51f25.svg";